import { EditCarLicensee } from '~/features/common/Organization/CarLicensees/EditCarLicensee'
import { EmployeesCarLicensee } from '~/features/common/Organization/CarLicensees/EmployeesCarLicensee'
import { Tabs } from '~/shared/ui/RoutesTabs/type'

export const useConfigTabs = (): Tabs => {
  return [
    {
      labelI18n: 'information',
      path: '/details',
      content: <EditCarLicensee />,
    },
    {
      labelI18n: 'employees',
      path: '/employees',
      content: <EmployeesCarLicensee />,
    },
  ]
}
